import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
} from "@chakra-ui/react";
import { Breadcrumb as BreadcrumbType } from "@types/common";
import React, { memo } from "react";

interface Props {
  links: BreadcrumbType[];
  // All other props
  [x: string]: any;
}

const LinkBreadcrumb: React.FC<Props> = ({ links, ...restprops }) => {
  return (
    <Breadcrumb color={"misc650"} fontSize="m" {...restprops}>
      {links?.map((link, index) => (
        <BreadcrumbItem key={index} isCurrentPage={index === links.length - 1}>
          {index === links.length - 1 ? (
            <Box color={"blue500"}>{link.label}</Box>
          ) : (
            <BreadcrumbLink href={link.href} color={"misc650"}>
              {link.label}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
      ))}
    </Breadcrumb>
  );
};

export default memo(LinkBreadcrumb);
